import View from './view';
import {IOwnProps, Props} from './model';
import {pollDetailsSelector} from '../../../../redux/selectors/polls';
import {useSelector} from 'react-redux';

export const SurveyCongratsMessage = (ownProps: IOwnProps) => {
  const pool = useSelector(pollDetailsSelector());
  const props: Props = {
    ...ownProps,
    congratulationMessage: pool?.descriptionFinish || 'Ваше мнение очень важно для нас!',
  };

  return View(props);
};
